import React from 'react';
import { QRCode as QR } from 'react-qrcode-logo';

import { trackCheckInQRDownload } from '../../analytics';

import { isEmpty } from '../../utils';

export const QRCode = (props: {
  eventId: string;
  link: string;
  size?: number;
}) => {
  const { eventId, link, size } = props;

  if (isEmpty(eventId)) return null;

  return (
    <React.Fragment>
      {/* qr code for display – if required */}
      {!!size && <QR value={link} size={size} quietZone={0} />}

      {/* qr code for download – is hidden */}
      <div className="hidden">
        <QR
          id={`check-in-qr-${eventId}`}
          value={link}
          size={500}
          quietZone={0}
        />
      </div>
    </React.Fragment>
  );
};

export const downloadQRCode = (
  eventId: string,
  eventName: string,
  source: string,
) => {
  const canvas = document.getElementById(
    `check-in-qr-${eventId}`,
  ) as HTMLCanvasElement;

  if (canvas) {
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `CrowdClip QR Code - ${eventName}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    trackCheckInQRDownload(source);
  }
};
